import React from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import Suppliers from './Suppliers';

export default function SupplierPage() {
  const { authorizedUser } = useSelector(
    ({ auth }) => ({
      authorizedUser: auth.user,
    }),
    shallowEqual
  );
  return (
    <div>
      <Suppliers authorizedUser={authorizedUser} />
    </div>
  );
}
